import { render, staticRenderFns } from "./facebookData.vue?vue&type=template&id=6ef39137&scoped=true&"
import script from "./facebookData.vue?vue&type=script&lang=js&"
export * from "./facebookData.vue?vue&type=script&lang=js&"
import style0 from "./facebookData.vue?vue&type=style&index=0&id=6ef39137&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef39137",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ef39137')) {
      api.createRecord('6ef39137', component.options)
    } else {
      api.reload('6ef39137', component.options)
    }
    module.hot.accept("./facebookData.vue?vue&type=template&id=6ef39137&scoped=true&", function () {
      api.rerender('6ef39137', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/management/components/facebookData.vue"
export default component.exports